import React from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Treatments from "./components/Treatments";
import About from "./components/About";
import Doctor from "./components/Doctor";
import Gallery from "./components/Gallery";
import AppointmentForm from "./components/AppointmentForm";
import Contact from "./components/Contact";
import Footer from "./components/Footer";


function App() {
	return (
		<>
			<Navbar />
			<div className="fade-in"><Hero /></div>
			<hr className="section-divider" />
			<div className="fade-in"><Treatments /></div>
			<hr className="section-divider" />
			<div className="fade-in"><About /></div>
			<hr className="section-divider" />
			<div className="fade-in"><Doctor /></div>
			<hr className="section-divider" />
			<div className="fade-in"><Gallery /></div>
			<hr className="section-divider" />
			<div className="fade-in"><AppointmentForm /></div>
			<hr className="section-divider" />
			<div className="fade-in"><Contact /></div>
			<Footer />

			{/* WhatsApp Floating Button */}
			<a
				href="https://wa.me/1234567890"
				className="whatsapp-float"
				target="_blank"
				rel="noopener noreferrer"
			>
				💬
			</a>
		</>
	);
}


export default App;